/**
 * @param {object} user - from /auth/me/ (first_name, last_name, display_name, email, username)
 */
export function getUserInitials(user) {
  if (!user) return '?';
  const fn = (user.first_name || '').trim();
  const ln = (user.last_name || '').trim();
  if (fn && ln) return `${fn[0]}${ln[0]}`.toUpperCase();
  const dn = (user.display_name || '').trim();
  if (dn) {
    const parts = dn.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
    if (parts[0].length >= 2) return parts[0].slice(0, 2).toUpperCase();
    return parts[0][0].toUpperCase();
  }
  const e = user.email || user.username || '';
  return e.slice(0, 2).toUpperCase();
}
